import React from "react";
import { useLang } from "@/i18n/LangContext";
import { pageContent, pickLang } from "@/i18n/pageContent";

export const HeroSection = () => {
  const { lang } = useLang();
  const c = pickLang(pageContent.home, lang);
  return (
    <section
      data-testid="home-hero"
      className="relative w-full min-h-[55vh] sm:min-h-[65vh] flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="/media/lemmer-haven-hero.jpg"
          alt="Lemmer haven IJsselmeer"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(23,58,94,0.55) 0%, rgba(23,58,94,0.35) 40%, rgba(23,58,94,0.75) 100%)",
          }}
        />
      </div>

      <div className="ll-container relative z-10 py-16 sm:py-24">
        <div className="max-w-3xl">
          <span
            data-testid="hero-eyebrow"
            className="inline-block text-[#6BC0E8] font-[Poppins] font-semibold text-xs sm:text-sm uppercase tracking-[0.2em] mb-4 ll-fade-up"
          >
            {c.hero.eyebrow}
          </span>
          <h1
            data-testid="hero-title"
            className="text-white text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight mb-4 ll-fade-up"
            style={{ animationDelay: "0.05s" }}
          >
            {c.hero.title}
          </h1>
          <p
            data-testid="hero-subtitle"
            className="text-white/90 text-base sm:text-lg lg:text-xl font-[Inter] max-w-xl ll-fade-up"
            style={{ animationDelay: "0.12s" }}
          >
            {c.hero.subtitle}
          </p>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-10 pointer-events-none">
        <svg
          className="w-full block"
          viewBox="0 0 1440 60"
          preserveAspectRatio="none"
          style={{ height: 48 }}
          aria-hidden="true"
        >
          <path
            d="M0,30 C240,60 480,0 720,20 C960,40 1200,50 1440,20 L1440,60 L0,60 Z"
            fill="#FFFFFF"
          />
        </svg>
      </div>
    </section>
  );
};

export default HeroSection;
